var exports = {
  "k": "x4c3adb35--cef103--container",
};

module.exports = exports;
